import { ERROR_CODE } from '../../constants/errorCodes';

export const AUTO_HIDE_DURATION = 4000;

export const infoMessages = [
  'Request failed with status code 401',
];

export const successMessages = [
  'success',
  'Form saved successfully',
];

export const decisionNotSendMessage = [
  'Decision was not successfully sent to sap.',
]

export const importJobMessages = [
  'Job Cost from SAP Job does not exist in PARS database.',
]

export const verifyJobMessages = [
  'Material number brand does not exist.',
]

export const jobIsLockedMessage = [
  'Job is locked.',
]

export const requestHasBeenSentToApproverMessage = [
  'requestHasBeenSentToApprover'
]

export const noPicturesAreUploadedMessage = [
  'OperationDenied',
]

export const rateIsProvidedMessage = [
  'Rate has successfully been registered'
]

export const rateHasToBeDifferentMessage = [
  'Rate decision has to be different than the old one.'
]

export const specialErrors = [
  ERROR_CODE.LIMIT_REACHED,
  ERROR_CODE.NO_QUESTIONS,
  ERROR_CODE.NO_LIMIT_FOR_CC,
];



// WEBPACK FOOTER //
// ./src/components/FeedbackBar/constants.js